var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "50%",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.openDialog,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formInfo,
            rules: _vm.rules,
            inline: true,
            "label-width": "150",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "50%" },
              attrs: { label: "商户名称：", prop: "merchantId" },
            },
            [_c("span", [_vm._v(" " + _vm._s(_vm.formInfo.title))])]
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "50%" },
              attrs: { label: "课程账号类型：", prop: "courseGoodsId" },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "w100",
                  attrs: { clearable: "", placeholder: "请选择课程账号类型" },
                  model: {
                    value: _vm.formInfo.courseGoodsId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInfo, "courseGoodsId", $$v)
                    },
                    expression: "formInfo.courseGoodsId",
                  },
                },
                _vm._l(_vm.courseCatalogList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.courseGoodsName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "50%" },
              attrs: { label: "课程账号数：", prop: "buyTotalAmount" },
            },
            [
              _c("el-input-number", {
                staticClass: "w100",
                attrs: {
                  "controls-position": "right",
                  min: 1,
                  max: 100000000000,
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.formInfo.buyTotalAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "buyTotalAmount", $$v)
                  },
                  expression: "formInfo.buyTotalAmount",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("确定 ")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }